import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { CustomerService } from '../../../services/customer.service';
import { EraService } from '../../../services/era.service';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],

  imports: [TranslatePipe]
})
export class LogoutComponent implements OnInit {
  constructor(
    private router: Router,
    private authService: AuthService,
    private eraService: EraService,
    private customerService: CustomerService
  ) {}

  async ngOnInit(): Promise<void> {
    // Close the open patient (via lifecycle) then log out of ERA.
    // setSelectedCustomer(null) fires closePatient internally, so no separate call needed.
    try {
      await this.customerService.setSelectedCustomer(null);
    } catch (ignore) {}

    const activeUnit =
      this.authService.getUserProfile()?.activeOrganizationUnit;
    const isEraEnabled =
      !!activeUnit?.eraBaseUrl &&
      (!!activeUnit?.eraVisitEntries || !!activeUnit?.eraPrescriptions);
    if (isEraEnabled) {
      try {
        await this.eraService.eraLogout();
      } catch (ignore) {}
    }

    // continue standard log out process...
    await this.authService.logout();
    await this.router.navigate(['login']);

    // Reload window to remove local storage and possible cookies
    window.location.reload();
  }
}
